import React, { memo, useMemo } from 'react';
import TareHistoryRow from './TareHistoryRow';
import { SubNav } from '../../layout/submenu';
import { DataTable } from '../../widgets';
import { DataTableLoading, DataTableRecordsNotFound } from '../../widgets/DataTable';

const TareLoadHistory = ({ tareLoadList = [], data, getSeedTareHistory }) => {

	const { data: tareLoads, isRequesting } = useMemo(() => {
		const { data, isRequesting } = tareLoadList;
		return { data, isRequesting }
	}, [tareLoadList]);

	const customColumns = ["crew_name", "source_equipment_group_name", "source_operator_name", "target_equipment_group_name", "operator_name",
		"offload_geo_shape_name", "offload_geo_storage_location_name", "load_capacity", "load_date"];

	const nonEmptyColumns = useMemo(() => {
		const newCustomColumns = [];

		for (const item of tareLoads) {
			if (newCustomColumns.length === customColumns.length) break;

			for (const field of customColumns) {
				if (newCustomColumns.indexOf(field) >= 0) continue;
				else if (item[field] !== "Unknown" && item[field] !== "" && item[field] !== null && item[field] !== 0) newCustomColumns.push(field);
			};
		};

		return [...newCustomColumns, 'id']
	}, [tareLoads]);

	const header = data.tareLoads.header;

	return (
		<div style={{ marginTop: '20px' }}>
			<DataTable>
				<DataTable.Header >
					<DataTable.Row>
						{false &&
							<DataTable.Cell
								width="40px">
								<div
									style={{ overflow: 'hidden', paddingBottom: '16px' }}>
									<SubNav.Checkbox
										className="square"
										// checked={selectAll}
										onChange={(e) => console.log(e)}
									/>
								</div>
							</DataTable.Cell>}
						{header && header
							.filter(e => (isRequesting || (tareLoads && tareLoads.length === 0)) ? true : nonEmptyColumns.includes(e.key))
							.map((e, index) => (
								<DataTable.Cell
									key={index}
									width={e.width && e.width}
									id={e.key}
								>
									<span>
										<span>{e.label}</span>
										{/* <span>{renderSortOrder(e.key)}</span> */}
									</span>
									{/* {e.isPipeFilter && filter(e.filter)} */}
								</DataTable.Cell>
							))}

						<DataTable.Cell width={"80px"}>
							Action
						</DataTable.Cell>

					</DataTable.Row>
				</DataTable.Header>

				<DataTable.Body>
					{tareLoads && tareLoads.length > 0 &&
						tareLoads.map((e, index) =>
							<TareHistoryRow
								data={e}
								getSeedTareHistory={getSeedTareHistory}
								key={index}
								nonEmptyColumns={nonEmptyColumns}
								index={index + 1}
								isRequesting={false}
							/>)}
				</DataTable.Body>
			</DataTable>

			<div className='info-text'>
				{isRequesting && <DataTableLoading />}
				{!isRequesting && tareLoads && tareLoads.length === 0 && <DataTableRecordsNotFound />}
			</div>
		</div>
	);
};

export default memo(TareLoadHistory);